import { Component, input, viewChild } from '@angular/core';
import { ColDef, ColGroupDef } from 'ag-grid-community/dist/lib/entities/colDef';
import { GridComponent } from '../grid/grid.component';

@Component({
  selector: 'app-readonly-grid',
  templateUrl: './readonly-grid.component.html',
  styleUrl: './readonly-grid.component.scss',
  imports: [GridComponent],
})
export class ReadonlyGridComponent {
  public readonly grid = viewChild(GridComponent);

  public readonly stateKey = input<string>();
  public readonly header = input<string>();
  public readonly gridCssClass = input<string>();
  public readonly columnDefs = input<(ColDef | ColGroupDef)[]>([]);
  public readonly rowData = input<any>([]);
  public readonly sizeToFit = input(false);

  get gridStateKey() {
    return `Readonly.${this.stateKey() ?? this.header()}`;
  }
}
